import { ButtonERP } from "@finanedi.es/storybook"
import { PerceptorGetDatosDeclaracionModelo190DtoProps } from "api/DTOs/PerceptorGetDatosDeclaracionModelo190Dto"
import { FieldErrors, UseFormSetValue } from "react-hook-form"
import { useTranslation } from "react-i18next"
import DeclaradosTemplate from "./DeclaradosTemplate"
import { Modelo347Form } from "../DeclaracionModelo347"

const Declarados347 = ({
  setValue,
  values,
  errors,
}: {
  setValue: UseFormSetValue<$TSMigrationFixMe>
  values: $TSMigrationFixMe
  errors: FieldErrors<Modelo347Form>
}) => {
  const { t } = useTranslation()
  const declaradosCount = values?.declarados?.length ?? 1
  const handleAddInmueble = () => {
    const current = Array.isArray(values?.declarados) ? values.declarados : []
    const newInmueble = {}
    setValue("declarados", [...current, newInmueble], {
      shouldValidate: false,
      shouldDirty: true,
      shouldTouch: true,
    })
  }

  const handleDeleteInmueble = (index: number) => {
    const current = Array.isArray(values?.declarados) ? values.declarados : []
    const updated = current.filter(
      (_: PerceptorGetDatosDeclaracionModelo190DtoProps, idx: number) =>
        idx !== index
    )
    setValue("declarados", updated, {
      shouldValidate: true,
      shouldDirty: true,
      shouldTouch: true,
    })
  }

  return (
    <div
      title='Inmuebles'
      className='tw-w-full tw-px-4 tw-pb-4 tw-space-y-5'
    >
      <ButtonERP
        label={`${t("declaracionModelo347.declarados.addLabel")}`}
        customize={{ type: "primary", size: "md" }}
        onClick={handleAddInmueble}
      />

      {Array.from({ length: declaradosCount }).map((_, index) => (
        <DeclaradosTemplate
          t={t}
          // eslint-disable-next-line react/no-array-index-key
          key={`inmuebles_${index}`}
          text={`${t("declaracionModelo347.declarados.title")} ${index + 1}`}
          values={values}
          setValue={setValue}
          declaradoIndex={index}
          handleDelete={() => handleDeleteInmueble(index)}
          errors={errors}
        />
      ))}
    </div>
  )
}

export default Declarados347
